import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import LanguageIcon from '@mui/icons-material/Language';
import { Typography, Button } from '@mui/material';
import { MyContext } from '../../globalContext';

const LanguageSwitcher = () => {
    const { i18n } = useTranslation();
    const {setLanguageSwitchedData} = useContext(MyContext);
    const currentLanguage = i18n.language;
    const switchToLanguage = currentLanguage === 'es' ? 'en' : 'es';
    const buttonLabel = switchToLanguage === 'es' ? 'Español' : 'English';
   

    const changeLanguage = () => {
        setLanguageSwitchedData(switchToLanguage);
        i18n.changeLanguage(switchToLanguage);       
        
        
    }
     return (
        <Typography color="primary" data-testid="language-btn" sx={{ display: 'flex', justifyContent: 'flex-end', height: '100%' }} onClick={() => changeLanguage()}>
            <Button data-testid="languageSwitchBtn" sx={{ textTransform: "none" }} size="large"  endIcon={<LanguageIcon color="primary" />} className="switch-btn" tabIndex={-1}>
                {buttonLabel}
            </Button>
        </Typography>
    )
}

export default LanguageSwitcher